if (!customElements.get("el-cleanest-label")) {
  customElements.define(
    "el-cleanest-label",
    class ElCleanestLabel extends HTMLElement {
      connectedCallback() {
        this.openButtons = this.querySelectorAll("[data-nutrition-open]");
        this.closeButtons = this.querySelectorAll("[data-nutrition-close]");
        this.modal = this.querySelector("[data-nutrition-modal]");

        if (!this.modal) return;

        this.openButtons.forEach((button) => {
          button.addEventListener("click", this.openModal);
        });

        this.closeButtons.forEach((button) => {
          button.addEventListener("click", this.closeModal);
        });

        document.addEventListener("keydown", this.handleKeydown);
      }

      disconnectedCallback() {
        document.removeEventListener("keydown", this.handleKeydown);
      }

      openModal = () => {
        this.modal.classList.add("is-active");
        this.modal.setAttribute("aria-hidden", "false");
        document.documentElement.classList.add("el-cleanest-label-modal-open");
      };

      closeModal = () => {
        this.modal.classList.remove("is-active");
        this.modal.setAttribute("aria-hidden", "true");
        document.documentElement.classList.remove(
          "el-cleanest-label-modal-open",
        );
      };

      handleKeydown = (event) => {
        if (
          event.key === "Escape" &&
          this.modal.classList.contains("is-active")
        ) {
          this.closeModal();
        }
      };
    },
  );
}
